import React from "react";

export default function Hexagon(props) {
  return (
    <svg
      className="hexagon"
      viewBox="0 0 242 279"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id={`stripes-${props.id}`}
          patternUnits="userSpaceOnUse"
          width="4.5"
          height="4.5"
          patternTransform="rotate(30)"
        >
          <line x1={0} y={0} x2={0} y2={10} stroke="#fff" strokeWidth={2} />
        </pattern>
        <clipPath
          id={`hexagon-${props.id}`}
          clipPathUnits="objectBoundingBox"
          transform="scale(0.004132 0.003584)"
        >
          <path d="M11.0813268,63.3558358 C4.98154197,66.8645579 0,75.5063538 0.00612735789,82.5421523 L0.00612735789,85.310586 L0,85.310586 L0,196.488438 L0.00306367895,196.488438 C0.00306367895,200.535552 1.66357767,205.108821 4.24013166,208.950979 C6.13042157,211.75918 8.51090011,214.169706 11.0935815,215.6564 L84.4349918,257.93849 L109.921737,272.624955 C109.964628,272.658604 110.022838,272.680018 110.068794,272.710608 L110.117812,272.732021 C110.163768,272.753435 110.206659,272.774848 110.249551,272.79932 L120.990809,278.993882 L120.993873,279 L121,279 L131.756577,272.79932 C131.796405,272.774848 131.845423,272.750376 131.885251,272.732021 L131.93427,272.710608 C131.980225,272.683077 132.038435,272.655545 132.087454,272.624955 L156.315027,258.657365 L230.91561,215.653341 C233.565692,214.126879 236.007444,211.6307 237.922243,208.72155 C240.409951,204.937514 242,200.452958 242,196.488438 L241.993873,82.5421523 C242,80.1958665 241.433219,77.662979 240.468161,75.2065676 C238.531915,70.3090401 234.981112,65.6990626 230.91561,63.3527767 L230.906419,63.3588948 L230.912546,63.3527767 L132.096645,6.39339948 C132.087454,6.38422236 132.078263,6.38422236 132.059881,6.38422236 L120.993873,0 L120.993873,0.00305904282 L109.94931,6.37198618 C109.933992,6.37810427 109.924801,6.3872814 109.912546,6.3872814 L11.0813268,63.3527767" />
        </clipPath>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill={`url(#stripes-${props.id})`}
        clipPath={`url(#hexagon-${props.id})`}
        opacity={1}
      />
    </svg>
  );
}
